import React from 'react';
import { PropTypes } from 'prop-types';
import MessagingTokenProvider from './MessagingTokenProvider';
import ConversationsClientProvider from './ConversationsClientProvider';
import ChatUserProvider from './ChatUserProvider';
import ConversationsProvider from './ConversationsProvider';

// Just a wrapper for all the global messaging/conversation providers
const MessagingProviders = ({ children }) => (
    <MessagingTokenProvider>
        <ConversationsClientProvider>
            <ChatUserProvider>
                <ConversationsProvider>{children}</ConversationsProvider>
            </ChatUserProvider>
        </ConversationsClientProvider>
    </MessagingTokenProvider>
);

MessagingProviders.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default MessagingProviders;
